function Actions() {
	return <div id="documents-drawer" />;
}

export default Actions;
